import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import EdtDynamicCheckLogTable from './table/EdtDynamicCheckLogTable';
import EdtDynamicCheckLogEditForm from './editform/EdtDynamicCheckLogEditForm';

i18next.addResourceBundle('en', 'edtDynamicCheckLog', en);
i18next.addResourceBundle('hu', 'edtDynamicCheckLog', hu);

export default [
	{
		path: '/edt-dynamic-check-log/edit/:id/:tabKey?',
		component: EdtDynamicCheckLogEditForm,
		auth: authRoles.edtDynamicCheckLog
	},
	{
		path: '/edt-dynamic-check-log/:sessionNameParam?',
		component: EdtDynamicCheckLogTable,
		auth: authRoles.edtDynamicCheckLog
	}
];
